var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "check-circle-outline_svg__a",
  d: "M5.863 10.583L3.55 8.27a.664.664 0 10-.94.94l2.787 2.787c.26.26.68.26.94 0l7.053-7.054a.664.664 0 10-.94-.94l-6.587 6.58z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.9
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.5,
  stroke: "currentColor"
}), /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  transform: "translate(4 4)",
  xlinkHref: "#check-circle-outline_svg__a"
}));

var SvgCheckCircleOutline = function SvgCheckCircleOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckCircleOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-circle-outline.010d1007.svg";
export { ForwardRef as ReactComponent };